import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'recovery_forgot.title',
  },
  formTitle: {
    id: 'login_recovery.insert_infos_title',
  },
  formSubTitle: {
    id: 'login_recovery.insert_infos_subTitle',
  },
  cin: {
    id: 'login_recovery.insert_infos_CIN',
  },
  birthday: {
    id: 'login_recovery.insert_infos_birthday',
  },
  valid: {
    id: 'recovery_forgot_password.title_button_valid',
  },
  passwordForgot: {
    id: 'recovery_forgot_password.title',
  },
  requiredField: {
    id: 'required.field',
  },
  birthdayInputError: {
    id: 'signup_personal_info.birthday.error',
  },
  InfosError: {
    id: 'recovery_forgot_login.Infos',
  },
});
